import { ofType } from 'redux-observable';
import {
  catchError,
  delay,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, timer } from 'rxjs';
import { navigate } from '@reach/router';
import { httpMethods, request } from '../../../../../services/http-service';
import { UPSERT_PRATICA } from '../../data.const';
import {
  resetCurrentCreateSessionAction,
  setCurrentPraticaAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';
import { rootConfig } from '../../../../../config/root-config';

const upsertPraticaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(UPSERT_PRATICA),
    map(({ payload }: any) => {
      const { createdAt, updatedAt, ...rest } = payload;
      if (rest.id === 'crea') {
        delete rest.id;
      }
      return rest;
    }),
    tap((p) => console.log(`[epic ${UPSERT_PRATICA}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, state]) => {
      return concat(
        of(setLoaders({ praticaLoader: true, page: true })),
        defer(() =>
          from(
            request({ path: `pratica`, method: httpMethods.POST, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error(p.message);
              }
              return p?.result;
            }),
            switchMap((data) =>
              concat(
                of(setCurrentPraticaAction(data)),
                of(null).pipe(
                  tap(() => {
                    if (body?.id) {
                      return; // do not navigate in case of edit
                    }
                    navigate(
                      `${rootConfig.app_path}/gestionale/pratiche-edit/${
                        data?.id || 'crea'
                      }`
                    ).then(() => null);
                  }),
                  delay(500),
                  switchMap(() =>
                    of(
                      setPopupInfo({
                        opened: true,
                        message: 'Operazione completata con successo',
                        timer: 3000,
                      }),
                      resetCurrentCreateSessionAction()
                    )
                  )
                )
              )
            ),
            catchError((err) => {
              console.error(`[epic ${UPSERT_PRATICA}] error`, err);
              return of(
                setPopupInfo({
                  opened: true,
                  message: 'Operazione non riuscita',
                  type: 'BAD',
                  timer: 3000,
                })
              );
            })
          )
        ),
        of(setLoaders({ praticaLoader: false, page: false }))
      );
    })
  );

export default upsertPraticaEpic;
